import styled from 'styled-components';

const CloseImage = styled.img`
  width: ${({ width }) => width || '18px'};
  height: ${({ height }) => height || '18px'};
`;

export default CloseImage;
